import { RadioGroup, SxProps } from "@outschool/backpack";
import { EnglishProficiencyLevel } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

type EnglishProficiencyFilterProps = {
  onChange: (e: EnglishProficiencyLevel | null) => void;
  buttonSx?: SxProps;
  currentFilterProficiencyLevel?: EnglishProficiencyLevel | null;
};

export default function EnglishProficiencyFilter({
  currentFilterProficiencyLevel,
  onChange
}: EnglishProficiencyFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\EnglishProficiencyFilter"
  );
  const englishProficiencyOptions: Array<{
    value: EnglishProficiencyLevel | "Any";
    label: string;
    filterDropdownValue: string | undefined;
  }> = [
    {
      value: "Any",
      label: t("Any"),
      filterDropdownValue: undefined
    },
    {
      value: EnglishProficiencyLevel.A0,
      label: t("A0 - Absolute Beginner"),
      filterDropdownValue: "English: A0"
    },
    {
      value: EnglishProficiencyLevel.A05,
      label: t("A0.5 - Novice (<1 year) and below"),
      filterDropdownValue: "English: A0.5"
    },
    {
      value: EnglishProficiencyLevel.PreA1,
      label: t("Pre-A1 - Advanced Novice (1-2 years) and below"),
      filterDropdownValue: "English: Pre-A1"
    },
    {
      value: EnglishProficiencyLevel.A1,
      label: t("A1 - Beginner (2-3 years) and below"),
      filterDropdownValue: "English: A1"
    },
    {
      value: EnglishProficiencyLevel.A2,
      label: t("A2 - Elementary and below"),
      filterDropdownValue: "English: A2"
    },
    {
      value: EnglishProficiencyLevel.B1,
      label: t("B1 - Intermediate and below"),
      filterDropdownValue: "English: B1"
    },
    {
      value: EnglishProficiencyLevel.B2,
      label: t("B2 - Upper-Intermediate or below"),
      filterDropdownValue: "English: B2"
    }
  ];

  return (
    <RadioGroup
      name="englishProficiency"
      value={currentFilterProficiencyLevel || "Any"}
      options={englishProficiencyOptions.map(({ value, label }) => ({
        value,
        label
      }))}
      onChange={(_e, value) => {
        if (value === "Any") {
          onChange(null);
          return;
        }
        onChange(value as EnglishProficiencyLevel);
      }}
    />
  );
}
